import axios from 'axios'
import Toast from './toast'
import qs from 'qs'

function confirm(markAsLost, companionAnimalID, token, formData, listingId) {
  const action = markAsLost ? 'lost' : 'found'
  const notificationBody = markAsLost ? 'Companion animal marked as lost.' : 'Companion animal marked as found!'
  const urlParts = ['/api/companion-animal', action, companionAnimalID].join('/')
  const url = urlParts + '?FormToken=' + token
  let data = {}
  if (action === 'found') {
    data = {
      foundMethod: formData?.foundMethod ?? '',
      comment: formData?.comment ?? '',
      listingId: listingId,
    }
  }
  return axios({
    method: 'POST',
    url,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
    maxRedirects: 0,
  })
    .then((response) => {
      this.isLost = markAsLost
      this.showModal = false
      this.clearModal()
      if (this.refresh) {
        this.refresh()
      }
      this.$toast.success({
        component: Toast,
        props: {
          heading: 'Status updated',
          body: notificationBody,
        },
      })
    })
    .catch(() => {
      this.showFailureMessage = true
    })
}

export function confirmLost(companionAnimalID, token) {
  return confirm.apply(this, [!!'lost', companionAnimalID, token])
}

export function confirmFound(companionAnimalID, token, formData, listingId) {
  return confirm.apply(this, [!'lost', companionAnimalID, token, formData, listingId])
}

export function confirmRemovalAsGuardian(id, token, page) {
  let params = `?FormToken=${token}`
  if (page === 'Splash') {
    params += '&EmailLogin=true'
  }
  const url = `/my-companion-animals/deceased/${id}${params}`
  this.axios({
    url,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    maxRedirects: 0,
  })
    .then(() => {
      if (page === 'Splash') {
        window.location.reload()
      } else {
        // Redirect to dashboard as profile no longer accessible:
        window.removeEventListener('beforeunload', this.$parent.beforeUnload)
        window.location.pathname = '/my-companion-animals/'
      }
    })
    .catch(() => {
      this.showFailureMessage = true
    })
}

export function confirmRemovalAsImplanter(id, token) {
  const url = '/implanter/dashboard/deceased/' + id + '?FormToken=' + token
  this.axios({
    url,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    maxRedirects: 0,
  })
    .then(() => {
      this.clearModal()
      this.refresh()
      this.$toast.success({
        component: Toast,
        props: {
          heading: 'Status updated',
          body: "This companion animal is no longer visible on the guardian's dashboard",
        },
      })
    })
    .catch(() => {
      this.showFailureMessage = true
    })
}
